import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, ReplaySubject, of } from 'rxjs';
import { Router } from '@angular/router';
import { ApiService } from './api.service';
import { saveToken, destroyToken, hasToken, decodedToken, clearSessionData, isTokenExpired } from '../helpers/token.helper';
import { map, distinctUntilChanged, catchError } from 'rxjs/operators';
import { get } from "lodash";
import { PORTALTYPE } from "../helpers/enum.helper";
// import { ApiAdapter } from './Trainer/api.adapter.service';
import { Trainer } from '../models/trainer/trainer.model';
import { ITrainerAPI } from '../models/trainer/api.model';
import { ApiAdapter } from './trainer/api.adapter.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppLoaderService } from './app-loader.service';

@Injectable({
  providedIn: 'root'
})

export class TrainerService {

  private currentTrainerSubject = new BehaviorSubject<Trainer>({} as Trainer);
  public currentTrainer = this.currentTrainerSubject.asObservable().pipe(distinctUntilChanged());

  private isAuthenticatedSubject = new BehaviorSubject<boolean>(false);
  portalType = '';
  constructor(
    private apiService: ApiService,
    private router: Router,
    private adapter: ApiAdapter,
    private snackBar: MatSnackBar,  
    private loader: AppLoaderService,
  ) {

    if (isTokenExpired()) {
      this.purgeAuth();
    } else {
      this.isAuthenticatedSubject.next(hasToken());
      this.currentTrainerSubject.next(this.getSessionUser());
    }

  }

  // Verify JWT in localstorage with server & load user's info.
  // This runs once on application startup.
  signin(formData): Observable<ITrainerAPI> {
    return this.apiService.post('trainer/login', formData).pipe(map(response => this.adapter.adapt(response)),
    catchError(error => {
      let errorMessage = 'An unexpected error occurred. Please try again later.';

      if (error.status === 500) {
        errorMessage = 'Internal Server Error. Something went wrong.';
      } else if (error.status === 404) {
        errorMessage = 'Resource not found. Please check your request.';
      }

      this.snackBar.open(errorMessage, 'Close', {
        duration: 5000,
      });

      this.loader.close();
      return of(null);
    }));
  }

  otpVerify(formData): Observable<ITrainerAPI> {
    return this.apiService.post('trainer/login', formData).pipe(map(response => this.adapter.adapt(response)),
    catchError(error => {
      let errorMessage = 'An unexpected error occurred. Please try again later.';

      if (error.status === 500) {
        errorMessage = 'Internal Server Error. Something went wrong.';
      } else if (error.status === 404) {
        errorMessage = 'Resource not found. Please check your request.';
      }

      this.snackBar.open(errorMessage, 'Close', {
        duration: 5000,
      });

      this.loader.close();
      return of(null);
    }));
  }

  forgetpassword(formData): Observable<ITrainerAPI> {
    return this.apiService.post('forget', formData).pipe(
		  catchError((error) => {
			let errorMessage = 'An unexpected error occurred. Please try again later.';
			if (error.status === 500) {
			  errorMessage = 'Internal Server Error. Something went wrong.';
			} else if (error.status === 404) {
			  errorMessage = 'Resource not found. Please check your request.';
			} 
			this.snackBar.open(errorMessage, 'Close', {
			  duration: 5000,
			});
			this.loader.close();
			return of(null);
		  })
		);
  }


  setAuth(Trainer: Trainer) {
    // Save JWT sent from server in localstorage
    saveToken(Trainer.token);
    window.localStorage.setItem('sesUsr', JSON.stringify(Trainer));
    // Set current Trainer data into observable
    this.currentTrainerSubject.next(Trainer);
    // Set isAuthenticated to true
    this.isAuthenticatedSubject.next(true);
  }

  purgeAuth() {
    // Remove JWT from localstorage
    destroyToken();
    clearSessionData();
    // Set current user to an empty object
    this.currentTrainerSubject.next({} as Trainer);
    // Set auth status to false
    this.isAuthenticatedSubject.next(false);

  }


  sendResetLink(model: Trainer): Observable<ITrainerAPI> {
    let formData = new FormData();
    formData.append('email', model.email);
    return this.apiService.post('forget', formData).pipe(map(response => this.adapter.adapt(response)),
    catchError(error => {
      let errorMessage = 'An unexpected error occurred. Please try again later.';

      if (error.status === 500) {
        errorMessage = 'Internal Server Error. Something went wrong.';
      } else if (error.status === 404) {
        errorMessage = 'Resource not found. Please check your request.';
      }

      this.snackBar.open(errorMessage, 'Close', {
        duration: 5000,
      });

      this.loader.close();
      return of(null);
    }));
  }


  resetPassword(formData): Observable<ITrainerAPI> {
    return this.apiService.post('reset', formData).pipe(
		  catchError((error) => {
			let errorMessage = 'An unexpected error occurred. Please try again later.';
			if (error.status === 500) {
			  errorMessage = 'Internal Server Error. Something went wrong.';
			} else if (error.status === 404) {
			  errorMessage = 'Resource not found. Please check your request.';
			} 
			this.snackBar.open(errorMessage, 'Close', {
			  duration: 5000,
			});
			this.loader.close();
			return of(null);
		  })
		);
  }


  chagePassword(model: Trainer): Observable<ITrainerAPI> {
    const formData = new FormData();
    const token = decodedToken();
    formData.append('old_password', model.oldPassword);
    formData.append('new_password', model.newPassword);
    formData.append('email', get(token, 'aud'));
    return this.apiService.post('changepassword', formData).pipe(
		  catchError((error) => {
			let errorMessage = 'An unexpected error occurred. Please try again later.';
			if (error.status === 500) {
			  errorMessage = 'Internal Server Error. Something went wrong.';
			} else if (error.status === 404) {
			  errorMessage = 'Resource not found. Please check your request.';
			} 
			this.snackBar.open(errorMessage, 'Close', {
			  duration: 5000,
			});
			this.loader.close();
			return of(null);
		  })
		);
  }



  getCurrentUser(): Trainer {
    return JSON.parse(window.localStorage.getItem('sesUsr'));
  }


  get isLoggedIn() {
    return this.isAuthenticatedSubject.asObservable();
  }

  logout() {
    this.getPortalType();
    this.purgeAuth();
    this.goToLogin();
  }

  getSessionUser(): Trainer {
    return JSON.parse(window.localStorage.getItem('sesUsr'));
  }

  goToLogin() {
    if (this.portalType == PORTALTYPE.GYM) {
      this.router.navigate(['/']);
    } else if (this.portalType == PORTALTYPE.DIETITIAN) {
      this.router.navigate(['/dietitian']);
    } else if (this.portalType == PORTALTYPE.PHYSIOTHERAPIST) {
      this.router.navigate(['/physiotherapist']);
    } else if (this.portalType == PORTALTYPE.TRAINER) {
      this.router.navigate(['/trainer']);
    } else {
      this.router.navigate(['/']); //default
    }
  }



  getPortalType() {
    const token = decodedToken();
    this.portalType = get(token, 'type') ?? '';
  }



}